import * as yup from "yup";
export const registerYup = yup.object().shape({
  username: yup.string().required("Kullanıcı adı zorunludur"),
  email: yup
    .string()
    .email("Geçersiz e-posta adresi")
    .required("E-posta zorunludur"),

  // Şifre alanı güncellemesi:
  password: yup
    .string()
    .required("Şifre zorunludur")
    .length(6, "Şifre tam olarak 6 haneli olmalıdır")
    .matches(/^[0-9]+$/, "Şifre sadece rakamlardan oluşmalıdır"),

  city: yup.string().required("İl seçimi zorunludur"),
  district: yup.string().required("İlçe seçimi zorunludur"),
  role: yup.string().required("Kullanıcı tipi zorunludur"),
  subscription: yup.mixed().nullable(),
});
